module.exports = __webpack_public_path__ + "img/russia.ad525eef.svg";